<template>
  <div class="confetti-table-container" :class="classes">
    <slot />
  </div>
</template>

<script>
const CLASS_MAP = [
  ["hasTableHeading", "confetti-table-container-with-heading"],
];

// This component does not have parity with the Ember version.
export default {
  name: "ConfettiTableContainer",
  props: {
    hasTableHeading: {
      type: Boolean,
    },
  },
  computed: {
    classes() {
      return CLASS_MAP.reduce(
        (classes, [prop, className]) =>
          classes + (this[prop] ? ` ${className}` : ""),
        "",
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@import "confetti/scss/variables/layout";
@import "confetti/scss/variables/breakpoints";
@import "confetti/scss/variables/colors";
@import "confetti/scss/design/basic-panel";
@import "confetti/scss/tables/confetti-table-container";
</style>
